/* ============================================================================
   AO-Motion JS — Scroll-Reveals (Welle 1: Fundament)
   <ao-reveal>-freies, selektorbasiertes Auto-Targeting: Sections im <main>
   (außer der ersten = Hero/LCP) bekommen .ao-reveal und blenden beim ersten
   Sichtbarwerden einmalig ein. Manuell: Klasse .ao-reveal an beliebige
   Elemente, Stagger über --ao-reveal-index (CSS-Var) oder data-ao-stagger
   am Container (nummeriert die direkten Kinder).
   Ohne JS: Klasse html.ao-motion fehlt -> alles sichtbar (CSS-Gate).
   Reduced Motion / Setting "aus": keine Beobachtung, alles sofort sichtbar.
   ========================================================================== */
(function () {
  'use strict';

  /* Lebenszeichen für das Sicherheitsnetz in ao-head.liquid: Bleibt diese Zeile aus
     (Datei lädt nicht, Syntaxfehler, CSP-Block), entfernt der dortige Timer nach 2,5 s
     die Gate-Klasse und macht alle .ao-reveal-Inhalte sichtbar. Muss deshalb GANZ OBEN
     stehen — vor allem, was werfen könnte. */
  window.__aoMotionReady = true;

  var root = document.documentElement;
  var motionOn = root.classList.contains('ao-motion');
  var reduced =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    root.classList.contains('ao-motion--off');

  function markAll(cls) {
    document.querySelectorAll('.ao-reveal').forEach(function (el) {
      el.classList.add('ao-in', cls || 'ao-instant');
    });
  }

  function init() {
    // Auto-Targeting: alle Sections im Main außer der ersten (Hero = LCP,
    // niemals per Opacity verstecken).
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (sec, i) {
      if (i === 0) return;
      // Leere/kollabierte Sektionen (z. B. deaktivierte Comments, h=0) nie
      // verstecken — ein IntersectionObserver feuert für sie unzuverlässig.
      if (sec.offsetHeight < 2) return;
      sec.classList.add('ao-reveal');
    });
    // Stagger-Container: nummeriert direkte Kinder für den CSS-Delay.
    document.querySelectorAll('[data-ao-stagger]').forEach(function (wrap) {
      Array.prototype.forEach.call(wrap.children, function (child, i) {
        child.classList.add('ao-reveal');
        child.style.setProperty('--ao-reveal-index', String(i));
      });
    });

    if (!motionOn || reduced || !('IntersectionObserver' in window)) {
      markAll();
      return;
    }

    var vh = window.innerHeight;
    // Robustheit: Beim Sprung-Scrollen (Scrollbalken-Drag, Ende-Taste) können
    // Elemente den Viewport ÜBERSPRINGEN, ohne je zu intersecten — sie blieben
    // unsichtbar. Sweep: alles, was bereits oberhalb des Viewports liegt,
    // sofort zeigen (ohne Animation).
    function sweepSkipped() {
      // Seitenende erreicht? Dann alles Verbliebene zeigen — Sektionen nahe
      // dem Dokumentende können sonst nie genug Sichtfläche aufbauen.
      var atEnd =
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - 4;
      document.querySelectorAll('.ao-reveal:not(.ao-in)').forEach(function (el) {
        if (atEnd || el.getBoundingClientRect().bottom < 0) {
          el.classList.add('ao-in', 'ao-instant');
          io.unobserve(el);
        }
      });
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ao-in');
          io.unobserve(entry.target);
        });
        sweepSkipped();
      },
      // threshold 0 statt 0.08: hohe Sektionen tief auf der Seite erreichen
      // die 8 %-Sichtfläche teils nie (Fund 2026-07-16, Rezept-Artikel).
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    var sweepPending = false;
    window.addEventListener('scroll', function () {
      if (sweepPending) return;
      sweepPending = true;
      setTimeout(function () { sweepPending = false; sweepSkipped(); }, 250);
    }, { passive: true });

    document.querySelectorAll('.ao-reveal').forEach(function (el) {
      // Beim Laden bereits (teilweise) sichtbare Elemente sofort zeigen —
      // kein Nachladen-Geflacker above the fold.
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) {
        el.classList.add('ao-in', 'ao-instant');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Welle 4: Cart-Bump — Hüpfer am Warenkorb-Button bei Inhaltsänderung. */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('ao-motion')) return;
  function arm() {
    var btn = document.querySelector('.button--cart-handle');
    if (!btn) return;
    var mo = new MutationObserver(function () {
      btn.classList.remove('ao-bump');
      void btn.offsetWidth; /* Reflow: Animation neu starten */
      btn.classList.add('ao-bump');
    });
    mo.observe(btn, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* A11y-Nachrüstung (Welle F2, 2026-07-16): Krowns Preis-Range-Vendor-Lib erzeugt
   role="slider"-Griffe ohne accessible name (axe: aria-input-field-name, serious).
   Vendor-Bundle bleibt unangetastet — Labels werden nachgerüstet, auch nach
   AJAX-Filter-Rerenders (Section Rendering ersetzt die Facets-DOM-Knoten).
   Labels über window.AO_I18N['ao.motion.min_price_label'/'max_price_label'] aus der
   Locale, deutscher Text bleibt Fallback (EN-Phase-2, i18n-js-Durchgang). */
(function () {
  'use strict';
  function label() {
    document.querySelectorAll('.range-slider__thumb[data-lower]:not([aria-label])')
      .forEach(function (t) { t.setAttribute('aria-label', (window.AO_I18N && window.AO_I18N['ao.motion.min_price_label']) || 'Mindestpreis'); });
    document.querySelectorAll('.range-slider__thumb[data-upper]:not([aria-label])')
      .forEach(function (t) { t.setAttribute('aria-label', (window.AO_I18N && window.AO_I18N['ao.motion.max_price_label']) || 'Höchstpreis'); });
  }
  function init() {
    label();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { label(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
